import React from 'react';
import TextField from 'material-ui/TextField';
import NumberFormat from 'react-number-format';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import Checkbox from 'material-ui/Checkbox';

import {
    Grid,
} from '../../components';
import {
    eventoService,
    subeventoService,
    areaService,
    projetosNotaFinalService,
    autorService,
} from '../../services';
import PrincipalMaster from '../master/Principal';

class ConfirmarApresentacao extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            dsEventos: [],
            dsSubeventos: [],
            dsAreas: [],
            eventoSelecionado: -1,
            subeventoSelecionado: -1,
            areaSelecionada: -1,
            dsProjetos: [],
            ano: 0,
        };
    }

    async componentWillMount() {
        const anoAtual = new Date().getFullYear();
        const eventos = await eventoService.getEventosPeloAno(anoAtual);
        this.setState({
            ano: anoAtual,
            dsEventos: eventos,
        });
    }
    async getProjetosAprovados(area) {
        const projetos = await projetosNotaFinalService.getProjetosAprovadosParaConfirmarApresentacao(area);
        this.setState({ dsProjetos: projetos });
    }

    async buscarSubEventosPeloEvento(evento) {
        //  this._csrf = (await subeventoService.subeventoForm()).token;
        this.setState({
            eventoSelecionado: evento,
            subeventoSelecionado: 0,
            areaSelecionada: 0,
        });

        const dadosSubevento = await subeventoService.getSubeventosDoEvento(evento);
        this.setState({ dsSubeventos: dadosSubevento });
    }

    async buscarEventosPeloAno(ano) {
        const eventos = await eventoService.getEventosPeloAno(ano);
        this.setState({ dsEventos: eventos });
    }

    async buscarAreasPeloSubEvento(subevento) {
        const areas = await areaService.getAreasCoordenador(subevento);
        this.setState({ dsAreas: areas, subeventoSelecionado: subevento });
    }

    buscarAreas(area) {
        let areaValidada = -1;
        if (area > 0) {
            areaValidada = area;
        }

        this.setState({ areaSelecionada: areaValidada });
        this.getProjetosAprovados(areaValidada);
    }

    async updateCheck(projeto, a, isChecked, indexProjeto, indexAutor) {
        const apresentou = (isChecked ? 1 : 0);
        const autor = parseInt(a);
        await autorService.update({ projeto, autor, apresentou });
        const { areaSelecionada } = this.state;
        this.getProjetosAprovados(areaSelecionada);
    }

    render() {
        const {
            dsEventos,
            eventoSelecionado,
            areaSelecionada,
            subeventoSelecionado,
            dsSubeventos,
            dsAreas,
            ano,
            dsProjetos,
        } = this.state;

        return (
            <PrincipalMaster title="Confirmar Apresentação dos Resumos/Projetos" {...this.props}>
                <div>
                    <div className="padding-content">
                        <NumberFormat
                            format="####"
                            customInput={TextField}
                            required
                            value={ano}
                            errorText={ano ? '' : 'Campo obrigatório'}
                            floatingLabelText="Ano"
                            onBlur={e => this.buscarEventosPeloAno(e.target.value)}
                            onChange={e => this.setState({ ano: e.target.value })}
                        />
                        <br />

                        <SelectField
                            floatingLabelText="Selecione um evento"
                            value={eventoSelecionado}
                            onChange={(_event, _index, value) => this.buscarSubEventosPeloEvento(value)}
                            errorText={eventoSelecionado > 0 ? '' : 'Campo obrigatório'}
                            fullWidth
                        >
                            {
                                dsEventos.map(evento => (
                                    <MenuItem key={evento.CODIGO} value={evento.CODIGO} primaryText={evento.NOME} />
                                ))
                            }
                        </SelectField>

                        <SelectField
                            floatingLabelText="Selecione um subevento"
                            value={subeventoSelecionado}
                            onChange={(_event, _index, value) => this.buscarAreasPeloSubEvento(value)}
                            errorText={subeventoSelecionado > 0 ? '' : 'Campo obrigatório'}
                            fullWidth
                        >
                            <MenuItem value={0} />
                            {
                                dsSubeventos.map(subevento => (
                                    <MenuItem key={subevento.CODIGO} value={subevento.CODIGO} primaryText={subevento.NOME} />
                                ))
                            }
                        </SelectField>

                        <SelectField
                            floatingLabelText="Selecione uma área"
                            value={areaSelecionada}
                            onChange={(_event, _index, value) => this.buscarAreas(value)}
                            errorText={areaSelecionada > 0 ? '' : 'Campo obrigatório'}
                            fullWidth
                        >
                            <MenuItem value={0} />
                            {
                                dsAreas.map(area => (
                                    <MenuItem key={area.CODIGO} value={area.CODIGO} primaryText={area.NOME} />
                                ))
                            }
                        </SelectField>

                    </div>
                </div>

                <div>
                    <div className="padding-content">
                        <Grid
                            ref={(ref) => { this.projetosGridRef = ref; }}
                            stripedRows="true"
                            textTableEmpty="Nenhum resumo/projeto encontrado."
                            dataSource={dsProjetos}
                            columns={[
                                {
                                    text: 'Título', name: 'TITULO', allowSort: true, allowSearch: true, searchOperator: 'LIKE',
                                },
                                {
                                    text: 'Modalidade', name: 'MODALIDADE', allowSort: true, allowSearch: true, searchOperator: 'LIKE', width: '100px',
                                },
                                {
                                    text: 'Autores',
                                    name: (item, indexProjeto) => (
                                        item.AUTORES.split(',').map((autor, indexAutor) => {
                                            const a = autor.split('-');
                                            return (
                                                <Checkbox
                                                    checked={a[2] === '1'}
                                                    label={a[1]}
                                                    onCheck={(event, isChecked) => this.updateCheck(item.CODIGO, a[0], isChecked, indexProjeto, indexAutor)}
                                                />
                                            );
                                        })
                                    ),
                                },
                            ]}
                        />
                    </div>

                </div>
            </PrincipalMaster>
        );
    }
}

export default ConfirmarApresentacao;
